import React from "react";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';
import moment from "moment";
import { CiCalendar } from "react-icons/ci";
import { Link } from "react-router-dom";

const BlogCard2 = ({ id, title, description, date, image, loading, index }) => {
 

  return (
    <div className="blog-card-2">
       
       
            <div className="loading-img">
           <Skeleton   width="100%" />
           </div>
       

      <div className="blog-loading-content">
                  <Skeleton width="80px"   />

          <Skeleton width="200px" height="15px" />
    
                   <Skeleton width="150px" height="15px" />

         
        
   
        
 

 
      </div>
    </div>
  );
};

export default BlogCard2;
